import api from '../api'

export function fetchSearchKey() {
  	return (dispatch) => api.fetch('/search-key')
	    .then((response) => {
		   	 dispatch({ type: 'FETCH_SEARCH_KEY_SUCCESS',response})
	    })
	     .catch(err => {
		})
}





// WEBPACK FOOTER //
// ./src/actions/searchKey.js